import request from '@/utils/request'

// 查询用户列表
export function getUserList(data) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: data
  })
}

// 查询用户详细
export function getUser(id) {
  return request({
    url: '/system/user/' + id,
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(id) {
  return request({
    url: '/system/user/' + id,
    method: 'delete'
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(data) {
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(id) {
  return request({
    url: '/system/user/resetPwd/' + id,
    method: 'put'
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get'
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data
  })
}

// 获取用户所拥有的项目权限-大屏 懒加载
export function getRootOrChildProjectByUser(id) {
  return request({
    url: '/project/getRootOrChildProjectByUser/' + id,
    method: 'get'
  })
}

// 获取用户所拥有的根项目权限
export function getRootProjectByUser() {
  return request({
    url: '/project/getRootProjectByUser',
    method: 'get'
  })
}
// 获取用户最后选中的项目
export function userProjectSelected() {
  return request({
    url: '/project/userProjectSelected',
    method: 'get'
  })
}
// 设置用户选中的项目
export function saveUserProjectSelected(data) {
  return request({
    url: '/project/saveUserProjectSelected',
    method: 'post',
    data: data
  })
}
// 根据子项目id获取当前用户所拥有最高权限的上级项目id
export function getRootByChildForUser(params) {
  return request({
    url: '/project/getRootByChildForUser',
    method: 'get',
    params: params
  })
}

// 获取详情下设备列表
export function getEqpList(query) {
  return request({
    url: '/shell/eqp/page/query/all',
    method: 'get',
    params: query
  })
}
